import { canonicalRole } from './role-names';
import { UserRole } from './user.model';

/** Libellés français des rôles de CDT, tels que la direction les lit dans l'application. */
export const userRoleLabels: Record<UserRole, string> = {
  'cdt-assistant-de-production': 'Assistant de production',
  'cdt-administration-du-personnel': 'Administration du personnel',
  'cdt-responsable-exploitation': "Responsable d'exploitation",
  'cdt-responsable-paie': 'Responsable paie',
  'cdt-directeur-rh': 'Directeur RH',
  'cdt-responsable-rh': 'Responsable RH',
  'cdt-directeur-agence': "Directeur d'agence",
  'cdt-directeur-admin-financier': 'Directeur administratif et financier',
  'cdt-directeur-general': 'Directeur général',
  'cdt-directeur-production': 'Directeur de production',
  'cdt-process-manager': 'Gestionnaire des processus CDT',
};

/** Libellé d'un rôle ; un rôle que l'application ne connaît pas garde son nom technique. */
export function userRoleLabel(role: string): string {
  return userRoleLabels[canonicalRole<UserRole>(role)] ?? role;
}
